export class WebhookLog {
  event: string;
  timestamp: number;

  constructor (data?: Partial<WebhookLog>) {
    this.event = data?.event || '';
    this.timestamp = data?.timestamp || 0
  }
}